import script from "./howitWorksSection.vue?vue&type=script&setup=true&lang=js"
export * from "./howitWorksSection.vue?vue&type=script&setup=true&lang=js"

import "./howitWorksSection.vue?vue&type=style&index=0&id=ef56874c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef56874c"]])

export default __exports__